import { render, staticRenderFns } from "./selectRole.vue?vue&type=template&id=5f16c94c&scoped=true&"
import script from "./selectRole.vue?vue&type=script&lang=js&"
export * from "./selectRole.vue?vue&type=script&lang=js&"
import style0 from "./selectRole.vue?vue&type=style&index=0&id=5f16c94c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f16c94c",
  null
  
)

export default component.exports